// Tiny, purely-decorative bottom-right resize-hint mark. Place it inside any
// CSS-resizable container (Result pane, AI Assistant scroll area, Slot wrappers,
// staging textarea wrapper, etc.) so the user can SEE that the box is draggable.
// `pointer-events: none` so it never intercepts the actual native resize handle —
// users still drag the bottom-right corner of the underlying element.
//
// Usage:
//   <div style={{ position: "relative", resize: "vertical", overflow: "auto" }}>
//     ...content...
//     <ResizeHint />
//   </div>
//
// For native <textarea> elements (which have their own resize handle), drop this
// hint inside an absolutely-positioned wrapper that ALSO contains the textarea.

export default function ResizeHint({ position = "bottom-right", title = "Drag to resize" }) {
  const stylePos = position === "bottom-right"
    ? { right: 2, bottom: 2 }
    : position === "bottom-left"
      ? { left: 2, bottom: 2 }
      : {};
  return (
    <span
      aria-hidden="true"
      title={title}
      data-testid="resize-hint"
      style={{
        position: "absolute",
        ...stylePos,
        width: 12,
        height: 12,
        pointerEvents: "none",
        opacity: 0.55,
      }}
    >
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Three diagonal hairlines mimicking the macOS/Windows resize-corner glyph. */}
        <line x1="11" y1="3" x2="3" y2="11" stroke="#6B6A68" strokeWidth="1" strokeLinecap="round" />
        <line x1="11" y1="6" x2="6" y2="11" stroke="#6B6A68" strokeWidth="1" strokeLinecap="round" />
        <line x1="11" y1="9" x2="9" y2="11" stroke="#6B6A68" strokeWidth="1" strokeLinecap="round" />
      </svg>
    </span>
  );
}
